(function () {
  function getSelectedVariant(button) {
    const card = button.closest('[data-custom-cart-upsell-card]');
    if (!card) return Number(button.dataset.variantId);
    const select = card.querySelector('[data-custom-cart-upsell-variant-select]');
    if (select) return Number(select.value);
    return Number(button.dataset.variantId);
  }

  function showButtonError(button, message) {
    const original = button.dataset.originalText || button.textContent;
    button.dataset.originalText = original;
    button.textContent = message;
    setTimeout(function () { button.textContent = original; }, 2500);
  }

  async function addOrderBump(button) {
    const variantId = getSelectedVariant(button);
    if (!variantId) {
      showButtonError(button, 'Select an option');
      return;
    }

    button.disabled = true;
    button.style.pointerEvents = 'none';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      const data = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        throw new Error(data.description || 'Unable to add product');
      }

      window.location.reload();
    } catch (error) {
      console.error('[order-bump]', error);
      showButtonError(button, 'Try again');
      button.disabled = false;
      button.style.pointerEvents = '';
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-custom-cart-order-bump-add]');
    if (!button) return;
    event.preventDefault();
    addOrderBump(button);
  });
})();
